<!-- Modern Set Password Component -->
<div class="set-password-container">
  <!-- Background Pattern -->
  <div class="background-pattern"></div>
  
  <!-- Main Set Password Card -->
  <div class="set-password-card">
    <!-- Header Section -->
    <div class="set-password-header">
      <div class="logo-section">
        <div class="logo-icon">
          <i class="pi pi-key"></i>
        </div>
        <h1 class="set-password-title">Set Password</h1>
        <p class="set-password-subtitle">Create a secure password for your account.</p>
      </div>
    </div>

    <!-- Set Password Form -->
    <div class="set-password-form-container">
      <form (ngSubmit)="onResetSubmit()" [formGroup]="newPasswordForm" class="set-password-form">
        
        <!-- Password Field -->
        <div class="form-field">
          <label for="password" class="form-label">
            <i class="pi pi-lock"></i>
            Password
          </label>
          <div class="input-container">
            <input
              id="password"
              type="password"
              formControlName="password"
              class="modern-input"
              placeholder="Enter your password"
              [class.input-error]="submitted && fn.password.errors"
            />
            <i class="pi pi-lock input-icon"></i>
          </div>
          <div *ngIf="submitted && fn.password.errors" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            <span *ngIf="fn.password.errors.required">Password is required</span>
          </div>
        </div>

        <!-- Confirm Password Field -->
        <div class="form-field">
          <label for="confirmPassword" class="form-label">
            <i class="pi pi-lock"></i>
            Confirm Password
          </label>
          <div class="input-container">
            <input
              id="confirmPassword"
              type="password"
              formControlName="confirmPassword"
              class="modern-input"
              placeholder="Confirm your password"
              [class.input-error]="submitted && fn.confirmPassword.errors"
            />
            <i class="pi pi-lock input-icon"></i>
          </div>
          <div *ngIf="submitted && fn.confirmPassword.errors" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            <span *ngIf="fn.confirmPassword.errors.required">Password confirmation is required</span>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="form-actions">
          <button
            type="submit"
            class="set-password-button"
            [disabled]="loading"
            [class.loading]="loading"
          >
            <span *ngIf="!loading" class="button-content">
              <i class="pi pi-check"></i>
              Set Password
            </span>
            <span *ngIf="loading" class="button-content">
              <i class="pi pi-spinner pi-spin"></i>
              Setting Password...
            </span>
          </button>
        </div>

        <!-- Error Message -->
        <div *ngIf="error" class="error-container">
          <div class="error-alert">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ error }}</span>
          </div>
        </div>
      </form>
    </div>

    <!-- Footer Section -->
    <div class="set-password-footer">
      <p class="footer-text">
        <i class="pi pi-shield"></i>
        Secure password setup powered by Backflow Integration
      </p>
    </div>
  </div>
</div>
